import React from 'react';
import Button from '../../../../components/button/button';
import './review-next-site.css';

const ReviewNextSite = (props) => {
  const handleClick = () => {
    const isValid = props.validate();
    if (isValid) {
      props.handleValid();
    } else {
      props.handleInvalid();
    }
  };

  return (
    <div className="row review-next-site">
      <div className="col-12">
        <Button
          className="button do-business"
          buttonText={props.buttonText}
          onClick={handleClick}
          disabled={props.reviewDisabled}
        />
      </div>
    </div>
  );
};

export default ReviewNextSite;
